/**
 * @generated SignedSource<<ccfc54ee63e09301d381c20cf5b8525d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraTimeFormat = "DAYS" | "HOURS" | "PRETTY" | "%future added value";
export type JiraTimeUnit = "DAY" | "HOUR" | "MINUTE" | "WEEK" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type timeTrackingField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly originalEstimate: {
    readonly timeInSeconds: AGG$Long | null;
  } | null;
  readonly remainingEstimate: {
    readonly timeInSeconds: AGG$Long | null;
  } | null;
  readonly timeTrackingSettings: {
    readonly defaultFormat: JiraTimeFormat | null;
    readonly defaultUnit: JiraTimeUnit | null;
    readonly isJiraConfiguredTimeTrackingEnabled: boolean | null;
    readonly workingDaysPerWeek: number | null;
    readonly workingHoursPerDay: number | null;
  } | null;
  readonly " $fragmentType": "timeTrackingField_updateWorkItemAllFieldTypesActionRenderer";
};
export type timeTrackingField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: timeTrackingField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeTrackingField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "timeInSeconds"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "timeTrackingField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraTimeTrackingSettings",
      "kind": "LinkedField",
      "name": "timeTrackingSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isJiraConfiguredTimeTrackingEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "workingHoursPerDay"
        },
        {
          "kind": "ScalarField",
          "name": "workingDaysPerWeek"
        },
        {
          "kind": "ScalarField",
          "name": "defaultFormat"
        },
        {
          "kind": "ScalarField",
          "name": "defaultUnit"
        }
      ]
    },
    {
      "concreteType": "JiraEstimate",
      "kind": "LinkedField",
      "name": "originalEstimate",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraEstimate",
      "kind": "LinkedField",
      "name": "remainingEstimate",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "JiraTimeTrackingField"
};
})();

(node as any).hash = "5fec1c5c5a346c0074448461f24f884c";

export default node;
